import { createContext } from "react";

const SliderContext = createContext({
  isDragging: false,
  setIsDragging: (value: boolean) => {},
});

export default SliderContext;
